import { ENV } from '$env';
import { LoginPage } from '$pages/auth/login/login';
import { RegisterPage } from '$pages/auth/register/register';
import { RegisterCodePage } from '$pages/auth/register/register-code/register-code';
import { HomePage } from '$pages/home/home';
import { SettingsPage } from '$pages/settings/settings';
import { ItemProvider } from '$providers/item';
import { LoginProvider } from '$providers/login';
import { SettingsProvider } from '$providers/settings';
import { ViewProvider } from '$providers/view';
import { Component, ViewChild } from '@angular/core';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { Events, Nav, Platform } from 'ionic-angular';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = LoginPage;

  items: any;

  constructor(private platform: Platform, private statusBar: StatusBar, private splashScreen: SplashScreen,
    private events: Events, _item: ItemProvider, private loginProvider: LoginProvider,
    private _settings: SettingsProvider, private view: ViewProvider) {

    this._settings.loadSettingsFromServer().subscribe(
      (settings) => this.items = _item.getItems(settings).filter((i) => !i.hideMenu)
    );

    this.configureEnvironments();
    this.registerEvents();
    this.initializeApp();
  }

  private configureEnvironments() {
    console.debug(ENV.name);
    console.debug('URL de Conexão: ' + ENV.serverURL);

    if (ENV.production) {
      console.debug = () => { };
    }

    ENV.web = ENV.web && (this.platform.is('core') || this.platform.is('mobileweb'));
  }

  private registerEvents() {
    this.events.subscribe('app:checkRegister', (user, dispNotificados) => { this.checkRegister(user, dispNotificados); });
    this.events.subscribe('app:login', () => { this.login(); });
    this.events.subscribe('app:logout', () => { this.logout(); });
    this.events.subscribe('app:registro', (cpf) => { this.registroUsuario(cpf); });
    this.events.subscribe('app:notSession', () => {
      if (this._settings.get().autoLogin) {
        this.loginProvider.autoLogin(false);
      } else {
        this.logout();
        this.view.showMessage('Sua sessão expirou é necessário realizar o login novamente.');
      }
    });
  }

  private initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this._settings.load().subscribe(
        (settings) => {
          console.log('Configurações carregadas com sucesso. ');
          console.debug(settings);
          this.loginProvider.autoLogin();
        },
        (error) => { console.error('Não foi possível carregar as configurações. ' + error); }
      );
    });
  }

  /*####################################################
  ####################### EVENTS #######################
  ####################################################*/
  public registroUsuario(cpf?: string) {
    this.nav.push(RegisterPage, {
      cpf: cpf
    });
  }

  public showSettings() {
    this.nav.push(SettingsPage);
  }

  public checkRegister(user, dispNotificados) {
    this.nav.push(RegisterCodePage, { user: user, dispNotificados: dispNotificados });
  }

  public login() {
    this.nav.setRoot(HomePage);
  }

  public logout() {
    // Logout efetuado em LoginProvider
    this.nav.setRoot(LoginPage);
  }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts